/* Component Dependencies */
var navigationalPillsTemplate = require('templates/navigationalPills.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'navigationalPills',
  template: {
    'navigationalPills': navigationalPillsTemplate
  }
});
